import React, { Component } from "react";
import { Row, Col, Radio, Divider, Select } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { CasesByPetitionerLawfirmPerformanceChart, CasesByPatentOwnerLawfirmPerformanceChart } from "./charts";
import TopLawfirms from "./lawfirm-performance";
import { keepOnlyPTABQueryStrings } from "../../../../helpers/url";

const styles = {
  topParties: {
    textAlign: "center",
    margin: 16
  },
  minHeight: {
    minHeight: 600
  }
};

export default class CaseTabISIX extends Component {
  state = {
    pView: "list",
    poView: "list",
    pDisplaySize: 20,
    poDisplaySize: 20
  };

  render() {
    const q = keepOnlyPTABQueryStrings(this.props.location.query);
    const { pDisplaySize, poDisplaySize } = this.state;
    const navigateToCaseList = qs => v =>
      this.props.router.push({
        pathname: "/ptab/caselist",
        query: { ...q, [qs]: v.key }
      });
    const getGroupCount = (vals, group) => {
      let num = vals.filter(v => v.group === group);
      return num && num.length ? num[0].value : 0;
    };
    const callToClick = vals => {
      const numInst = getGroupCount(vals, "Instituted - Granted");
      const numNIM = getGroupCount(vals, "Not Instituted - Merits");
      const numFWDP = getGroupCount(vals, "All Claims Patentable");
      const score = (numInst - numNIM - 2 * numFWDP) / (numInst + numNIM);
      return (
        <span>
          <strong>{`ISIX: ${score.toFixed(2)}`}</strong>
          <br />
          <a>Click to View Cases</a>
        </span>
      );
    };
    return (
      <div>
        <div style={styles.minHeight}>
          <div style={styles.topParties}>
            <h3>
              {"Institutional Success IndeX (ISIX) – Petitioner Law Firm "}
              <a href="//support.unifiedpatents.com/hc/en-us/articles/115001551674-What-is-ISIX" target="_new">
                <QuestionCircleOutlined />
              </a>
            </h3>
            <Radio.Group onChange={e => this.setState({ pView: e.target.value })} value={this.state.pView}>
              <Radio.Button value="list">{"List View"}</Radio.Button>
              <Radio.Button value="chart">{"Chart View"}</Radio.Button>
            </Radio.Group>
            <Divider type="vertical" />
            <Select
              value={this.state.pDisplaySize}
              placeholder="Display Size"
              onChange={val => this.setState({ pDisplaySize: val })}
              getPopupContainer={trigger => trigger.parentNode}
              style={{ width: 180 }}
            >
              {[20, 50, 100].map(e => (
                <Select.Option value={e} key={e}>{`Show Top ${e}`}</Select.Option>
              ))}
            </Select>
          </div>
          <Row>
            {this.state.pView === "list" ? (
              <Col span={24} lg={{ span: 20, offset: 2 }} xl={{ span: 16, offset: 4 }}>
                <TopLawfirms type="p" query={{ ...q, size: pDisplaySize }} style={styles.topParties} />
              </Col>
            ) : (
              <CasesByPetitionerLawfirmPerformanceChart query={{ ...q, size: pDisplaySize }} onValueClick={navigateToCaseList("lawfirms.petitioner")} tooltipExtraRow={callToClick} />
            )}
          </Row>
        </div>
        <Divider />
        <div style={styles.minHeight}>
          <div style={styles.topParties}>
            <h3>
              {"Institutional Success IndeX (ISIX) – Patent Owner Law Firm "}
              <a href="//www.unifiedpatents.com/tools" target="_blank" rel="noopener noreferrer">
                <QuestionCircleOutlined />
              </a>
            </h3>
            <Radio.Group onChange={e => this.setState({ poView: e.target.value })} value={this.state.poView}>
              <Radio.Button value="list">{"List View"}</Radio.Button>
              <Radio.Button value="chart">{"Chart View"}</Radio.Button>
            </Radio.Group>
            <Divider type="vertical" />
            <Select
              value={this.state.poDisplaySize}
              placeholder="Display Size"
              onChange={val => this.setState({ poDisplaySize: val })}
              getPopupContainer={trigger => trigger.parentNode}
              style={{ width: 180 }}
            >
              {[20, 50, 100].map(e => (
                <Select.Option value={e} key={e}>{`Show Top ${e}`}</Select.Option>
              ))}
            </Select>
          </div>
          <Row>
            {this.state.poView === "list" ? (
              <Col span={24} lg={{ span: 20, offset: 2 }} xl={{ span: 16, offset: 4 }}>
                <TopLawfirms type="po" query={{ ...q, size: poDisplaySize }} style={styles.topParties} />
              </Col>
            ) : (
              <CasesByPatentOwnerLawfirmPerformanceChart query={{ ...q, size: poDisplaySize }} onValueClick={navigateToCaseList("lawfirms.patent_owner")} tooltipExtraRow={callToClick} />
            )}
          </Row>
        </div>
      </div>
    );
  }
}
